'use client'

import React, { useEffect, useRef } from 'react';
import DashButtons from '@/components/buttons/dash-buttons';
import { useStateStore } from '@/context/stateStore';
import { useSession } from 'next-auth/react';
import { ICycle } from '@/models/types/cycle';
import { INote } from '@/models/types/note';
import { IPlant } from '@/models/types/plant';


export default function Page() {

  const init = useRef(false);
  const { data: session } = useSession();
  const setGlobalLoading = useStateStore(state => state.setGlobalLoading);
  //const globalLoading = useStateStore(state => state.globalLoading); keeping this because I changed it in a way that is experimental to me
  const setCurrPlant = useStateStore(state => state.setCurrPlant);
  const setCurrCycle = useStateStore(state => state.setCurrCycle);
  const setCurrNote = useStateStore(state => state.setCurrNote);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.scrollTo(0, 0);
    }

    if (!init.current) {
      setCurrPlant({} as IPlant);
      setCurrCycle({} as ICycle);
      setCurrNote({} as INote);
      init.current = true;
      setGlobalLoading(false);
    }
  }, [init.current, setCurrPlant, setCurrCycle, setGlobalLoading, setCurrNote]);

  return (
    <DashButtons session={session} />
  );
}
